const configGetters = {
	tempObjDirection: state => state.tempObjDirection,
	tempFillDirection: state => state.tempFillDirection,
	tempImgZoomRate: state => state.tempImgZoomRate,
	tempActiveArea: state => state.tempActiveArea,
	tempRotateArea: state => state.tempRotateArea,
	temObjFormat: state => state.temObjFormat,
	tempRectTitle: state => state.tempRectTitle,
	tempCurrentImgIndex: state => state.tempCurrentImgIndex,
	tempRectExamNoInfo: state => state.tempRectExamNoInfo,
	tempScalePage: state => state.tempScalePage,
	tempEditImgInfo: state => state.tempEditImgInfo,
	tabActive: state => state.tabActive,
	typeLack: state => state.typeLack,
	tempChooseList: state => state.tempChooseList,
	operateCurPage: state => state.operateCurPage,
	tempSubList: state => state.tempSubList,
	tempSelLikeSubOrObjVal: state => state.tempSelLikeSubOrObjVal,
	tempExamNoType: state => state.tempExamNoType,
	tempLack: state => state.tempLack,
	tempRectObjective: state => state.tempRectObjective,
	tempRectSubjective: state => state.tempRectSubjective,
	tempTopicCurrentIndex: state => state.tempTopicCurrentIndex,
	tempScrollTop: state => state.tempScrollTop,
	tempScrollLeft: state => state.tempScrollLeft,
	tempOriginFlag: state => state.tempOriginFlag,
	tempFlushData: state => state.tempFlushData,
	tempRightKeyFixRectInfo: state => state.tempRightKeyFixRectInfo,
	tempReferTabState: state => state.tempReferTabState,
	groupListDetail: state => state.groupListDetail,
	tempObjTabState: state => state.tempObjTabState,
	chooseTabState: state => state.chooseTabState,
	dotType: state => state.dotType,
	tempReferRectList: state => state.tempReferRectList,
	tempSelLikeSubOrObj: state => state.tempSelLikeSubOrObj,
	tempSelLikeSubOrObjName: state => state.tempSelLikeSubOrObjName,
	tempSliceTopic: state => state.tempSliceTopic,
	tempCurrentRefer: state => state.tempCurrentRefer,
	tempSubTabState: state => state.tempSubTabState,
	tempFixRectTitle: state => state.tempFixRectTitle,
	tempExamObjAddRect: state => state.tempExamObjAddRect,
	tempHandleReset: state => state.tempHandleReset,
	tempRectSliceList: state => state.tempRectSliceList,
	handleSliceOriginClick: state => state.handleSliceOriginClick,
	handHandleState: state => state.handHandleState,
	wsState: state => state.wsState,
	tempObjTopic: state => state.tempObjTopic,
	canDrawRect: state => state.canDrawRect,
	handleSetObjVal: state => state.handleSetObjVal,
	copyObjState: state => state.copyObjState,
	objCanKeyDel: state => state.objCanKeyDel,
	tempSelLikeSub: state => state.tempSelLikeSub,
	tempRowNum: state => state.tempRowNum,
	tempInitObjTopic: state => state.tempInitObjTopic
}
export default configGetters
